/**
 * Types
 */
export const Types = {
  SET_MY_CLASSES: "studyGroup/SET_MY_CLASSES"
}
